import { authHeaders, requestJson } from './http';
import { demoActivities } from './mockData';

export async function listActivities(user) {
  if (!user?.jwt) return demoActivities;

  try {
    return await requestJson(
      '/api/strava-provider/get-activities?pagination[page]=1&pagination[pageSize]=100&sort[0]=start_date:desc',
      { headers: authHeaders(user) }
    );
  } catch (err) {
    return demoActivities;
  }
}

export function activityDistanceKm(activity) {
  const meters = Number(activity?.distance || 0);
  return Math.round((meters / 1000) * 100) / 100;
}
